
import { defineComponent, PropType } from 'vue'
import setLang from '@/scripts/root/setLang'
import { languageFlags } from '@/data/navigation/languageFlags'
import { SupportedLanguage } from '@/scripts/root/language'

export default defineComponent({
  props: {
    options: {
      type: Array as PropType<string[]>,
      required: true,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      selected:
        this.$store.getters.getAppLanguage ||
        (this.options.length > 0 ? this.options[0] : ''),
      filterOptions: this.options as string[],
      open: false,
      key: 0,
    }
  },
  watch: {
    '$route.params.lang'(newLang) {
      if (newLang && this.options.includes(newLang)) {
        this.updateSelectedLocale(newLang)
      }
    },
    '$i18n.locale'(newLocale) {
      this.updateSelectedLocale(newLocale)
    },
  },
  computed: {
    currentLanguage(): string {
      return this.$store.getters.getAppLanguage
    },
  },
  methods: {
    getLanguageLabel(lang: string): string {
      return String(this.$t(`navigation.navbar.languages.${lang}`))
    },
    getLanguageFlag(lang: string): string {
      return languageFlags[lang as SupportedLanguage] || '🌐'
    },
    changeLanguage(lang: string) {
      if (!this.options.includes(lang)) return
      setLang(lang)
      this.filterOptions = this.options.filter((option) => option !== lang)
    },
    updateSelectedLocale(locale: string) {
      if (!this.options.includes(locale)) return
      this.selected = locale
      this.filterOptions = this.options.filter((option) => option !== locale)
      this.$emit('input', this.selected)
      this.$store.commit('setAppLanguage', locale)
    },
  },
  mounted() {
    const savedLang = this.$store.getters.getAppLanguage

    if (savedLang && this.options.includes(savedLang)) {
      this.$i18n.locale = savedLang
      this.updateSelectedLocale(savedLang)
    } else {
      this.updateSelectedLocale(this.$i18n.locale)
    }
  },
})
